<template>
    <svg
        version="1.1"
        id="图层_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 1280 720"
        style="enable-background:new 0 0 1280 720;"
        xml:space="preserve"
    >
        <g>
            <circle class="st0" cx="421.7" cy="254.9" r="24.6" />
            <circle class="st1" cx="346" cy="288.3" r="24.6" />
            <circle class="st2" cx="317.5" cy="362.6" r="24.6" />
            <circle class="st3" cx="348.7" cy="435.4" r="24.6" />
            <circle class="st4" cx="421.7" cy="466.1" r="24.6" />

            <ellipse transform="matrix(0.1602 -0.9871 0.9871 0.1602 -15.2402 856.4873)" class="st5" cx="495.7" cy="437.2" rx="24.6" ry="24.6" />
            <circle class="st6" cx="528.7" cy="365.4" r="24.6" />

            <ellipse transform="matrix(0.1602 -0.9871 0.9871 0.1602 135.2004 739.229)" class="st7" cx="502" cy="290.2" rx="24.6" ry="24.6" />
        </g>
        <g>
            <g>
                <g>
                    <defs>
                        <circle id="SVGID_1_" cx="785.6" cy="522.5" r="120.7" />
                    </defs>
                    <clipPath id="SVGID_00000058578560589131419540000005683672373153448069_">
                        <use xlink:href="#SVGID_1_" style="overflow:visible;" />
                    </clipPath>

                    <g
                        id="snakeball_00000036213562261964741630000001917426128620088723_"
                        style="clip-path:url(#SVGID_00000058578560589131419540000005683672373153448069_);"
                    >
                        <g>
                            <circle class="st9" cx="762.2" cy="579.9" r="14" />
                            <circle class="st9" cx="765.2" cy="539.4" r="14" />
                            <circle class="st9" cx="777.8" cy="502.4" r="14" />
                            <circle class="st9" cx="798.9" cy="470.8" r="14" />
                            <circle class="st9" cx="827.4" cy="446.6" r="14" />
                            <circle class="st9" cx="861.3" cy="432.1" r="14" />
                            <circle class="st9" cx="897.8" cy="427.8" r="14" />
                            <circle class="st9" cx="934.9" cy="433.5" r="14" />
                            <circle class="st9" cx="970.3" cy="448.6" r="14" />
                            <circle class="st9" cx="1002" cy="473" r="14" />

                            <ellipse
                                transform="matrix(0.3827 -0.9239 0.9239 0.3827 166.8653 1261.9316)"
                                class="st9"
                                cx="1027.7"
                                cy="506.1"
                                rx="14"
                                ry="14"
                            />
                        </g>
                        <circle class="st9" cx="770.7" cy="638.9" r="28.1" />
                    </g>
                </g>
            </g>
            <circle class="st0" cx="728.8" cy="483.8" r="20.9" />
            <circle class="st10" cx="785.6" cy="522.5" r="120.7" />
            <g>
                <line class="st11" x1="880.6" y1="484.9" x2="932.1" y2="533.7" />
                <line class="st11" x1="932.1" y1="475.7" x2="880.6" y2="533.3" />
            </g>
        </g>
        <g>
            <g>
                <g>
                    <defs>
                        <circle id="SVGID_00000169519945166522389740000014819755588883336080_" cx="785.6" cy="198.5" r="120.7" />
                    </defs>
                    <clipPath id="SVGID_00000142890141186374965730000005667215483105903517_">
                        <use xlink:href="#SVGID_00000169519945166522389740000014819755588883336080_" style="overflow:visible;" />
                    </clipPath>

                    <g
                        id="snakeball_00000114777893864724983840000005972650244647262131_"
                        style="clip-path:url(#SVGID_00000142890141186374965730000005667215483105903517_);"
                    >
                        <g>
                            <circle class="st9" cx="834.2" cy="225.9" r="14" />
                            <circle class="st9" cx="865.4" cy="252" r="14" />
                            <circle class="st9" cx="888.1" cy="283.9" r="14" />
                            <circle class="st9" cx="901.5" cy="319.4" r="14" />
                            <circle class="st9" cx="904.5" cy="356.6" r="14" />
                            <circle class="st9" cx="896.5" cy="392.6" r="14" />
                            <circle class="st9" cx="878.6" cy="424.8" r="14" />
                            <circle class="st9" cx="852.4" cy="451.6" r="14" />
                            <circle class="st9" cx="819.4" cy="471.5" r="14" />
                            <circle class="st9" cx="781.2" cy="483.1" r="14" />
                            <circle class="st9" cx="739.2" cy="484.6" r="14" />
                        </g>
                        <circle class="st9" cx="781.4" cy="198.4" r="28.1" />
                    </g>
                </g>
            </g>
            <circle class="st0" cx="728.8" cy="159.8" r="20.9" />
            <circle class="st10" cx="785.6" cy="198.5" r="120.7" />
            <polyline class="st13" points="875.5,167 897.2,195.3 951,140.6 	" />
        </g>
    </svg>
</template>
     
<style scoped>
.st0 {
    fill: #16b7df;
}
.st1 {
    fill: #046312;
}
.st2 {
    fill: #ea4fc0;
}
.st3 {
    fill: #808080;
}
.st4 {
    fill: #9f4df0;
}
.st5 {
    fill: #113ede;
}
.st6 {
    fill: #ef7706;
}
.st7 {
    fill: #a37e22;
}
.st8 {
    clip-path: url(#SVGID_00000034087687760519555850000010805112038566615951_);
}
.st9 {
   fill: var(--color_back);
}
.st10 {
    fill: none;
    stroke: #8b8b8b;
    stroke-width: 9.6132;
    stroke-miterlimit: 10;
}
.st11 {
    fill: none;
    stroke: #dc1130;
    stroke-width: 22.2075;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-miterlimit: 10;
}
.st12 {
    clip-path: url(#SVGID_00000059301448227048254720000010677512276462998203_);
}
.st13 {
    fill: none;
    stroke: #0ee515;
    stroke-width: 27.7716;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-miterlimit: 10;
}
</style>
